/**
 * @generated SignedSource<<215083aa6d9ff22f8d8ec5d06bfd779c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiImageGenEditor_Query$variables = Record<PropertyKey, never>;
export type aiImageGenEditor_Query$data = {
  readonly imageGeneration: {
    readonly categoriesForEdit: ReadonlyArray<number>;
    readonly categoriesForGeneration: ReadonlyArray<number>;
    readonly id: string;
    readonly numberOfImagesEdit: number;
    readonly numberOfImagesGeneration: number;
  } | null;
  readonly imageGenerationPresetCategories: ReadonlyArray<{
    readonly categoryID: number;
    readonly name: string;
  }>;
};
export type aiImageGenEditor_Query = {
  response: aiImageGenEditor_Query$data;
  variables: aiImageGenEditor_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageGenerationDTO",
    "kind": "LinkedField",
    "name": "imageGeneration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "numberOfImagesGeneration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "numberOfImagesEdit",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoriesForGeneration",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoriesForEdit",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "ImageGenerationPresetCategoryInfoDTO",
    "kind": "LinkedField",
    "name": "imageGenerationPresetCategories",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoryID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "aiImageGenEditor_Query",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "aiImageGenEditor_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "3da6d83ed85ff299d4cb796e45ed3225",
    "id": null,
    "metadata": {},
    "name": "aiImageGenEditor_Query",
    "operationKind": "query",
    "text": "query aiImageGenEditor_Query {\n  imageGeneration {\n    id\n    numberOfImagesGeneration\n    numberOfImagesEdit\n    categoriesForGeneration\n    categoriesForEdit\n  }\n  imageGenerationPresetCategories {\n    categoryID\n    name\n  }\n}\n"
  }
};
})();

(node as any).hash = "a61cca706127a309d42859bddf74ee54";

export default node;
